import { render, staticRenderFns } from "./ManagePracticeClient.vue?vue&type=template&id=1ffc6e74&scoped=true"
import script from "./ManagePracticeClient.vue?vue&type=script&lang=js"
export * from "./ManagePracticeClient.vue?vue&type=script&lang=js"
import style0 from "./ManagePracticeClient.vue?vue&type=style&index=0&id=1ffc6e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc6e74",
  null
  
)

export default component.exports